import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { searchApi, type SearchResponse } from '@/services/api/search';

export function useGlobalSearch(query: string) {
  return useQuery<SearchResponse>({
    queryKey: ['globalSearch', query],
    queryFn: () => searchApi.search(query),
    enabled: query.length >= 2,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
